module.exports = __webpack_public_path__ + "ed9a2777d32313816a9623a451ebbfef.png";


//////////////////
// WEBPACK FOOTER
// ./images/user.png
// module id = ./images/user.png
// module chunks = 5